import gql from 'graphql-tag';

export default gql`
    query GetStageDetails($input: GetStageDetailsInput) {
        getStageDetails(input: $input) {
            isLastItem
            isPagingRequired
            wellName
            jobStatus
            isBellyDump
            stageDetails {
                stageGroupId
                stageSheetId
                jobStageId
                stage
                overallStage
                startDate
                endDate
                wellhead
                status
                comments
                fracType
            }
        }
    }
`;
